<template>
  <div
    class="reviews-section"
    :class="{ 'is-shown': isShown }"
  >
    <div v-if="editable">
      <div class="hide-overlay"></div>
      <b-button
        class="btn-toggle"
        :variant="isShown ? 'outline-danger' : 'outline-success'"
        size="sm"
        @click="isShown = !isShown"
      >
        <span v-if="isShown"><i class="material-icons">visibility_off</i> {{ name }} ausblenden</span>
        <span v-else><i class="material-icons">visibility</i> {{ name }} einblenden</span>
      </b-button>
    </div>
    <b-row>
      <b-col sm="9">
        <h3 :class="{ 'mb-2 heading-hidden': !isShown }">{{ heading }}</h3>
      </b-col>
      <b-col sm="3">
        <b-button
          class="float-right"
          @click="isCollapsed = !isCollapsed"
          type="button"
          variant="primary"
          size="sm"
          v-if="review.length > 4 && isShown"
        >
          {{ $t(isCollapsed ? 'actions.showMore' : 'actions.showLess') }}
        </b-button>
      </b-col>
    </b-row>
    <b-collapse
      :visible="isShown"
      :id="`collapse-${selfId}`"
    >
      <div style="position:relative">
        <transition-group
          v-masonry
          tag="div"
          class="row reviews"
          name="list"
          transition-duration="0.0s"
          item-selector=".review"
          @after-leave="afterLeave"
        >
          <b-col
            md="4"
            class="review list-item mb-4"
            v-for="review in shown"
            :key="`key-${review.id}`"
          >
            <b-card>
              <Review :review="getConstituents(review)" />
            </b-card>
            <small class="review-ref">
              <Author
                :author="getAuthor(review)"
                :show-author="showAuthor"
                :show-company="showCompany"
                :show-city="showCity"
                :show-date="showDate"
              />
            </small>
          </b-col>
        </transition-group>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import Review from './Review';
import Author from './Author';

export default {
  name: 'Reviews',
  props: {
    name: {
      type: String,
      default: 'Bewertungen'
    },
    heading: String,
    review: Array,
    hideAt: Number,
    constituents: Array,
    showAuthor: Boolean,
    showCompany: Boolean,
    showCity: Boolean,
    showDate: Boolean,
    initial: Boolean,
    editable: Boolean,
  },
  components: {
    Review,
    Author
  },
  data() {
    return {
      isCollapsed: true,
      isShown: false,
    }
  },
  mounted() {
    this.isShown = this.initial;
  },
  computed: {
    shown() {
      if (this.isCollapsed) {
        return this.review.slice(0, this.hideAt);
      }
      return this.review;
    },
    selfId() {
      return this.$attrs.id;
    }
  },
  methods: {
    afterLeave: function () {
      this.$redrawVueMasonry();
    },

    getAuthor: function (review) {
      let author = { ...review.author };
      return Object.assign(author, { date: review.createdAt });
    },

    getConstituents: function (review) {
      let result = {}
      this.constituents.forEach(constituent => {
        result[constituent] = review[constituent];
      });
      return result;
    },
  },
  watch: {
    isCollapsed: function (val) {
      this.$nextTick(() => {
        this.$redrawVueMasonry();
      })
    },
    isShown: function (value) {
      this.$nextTick(() => {
        this.$redrawVueMasonry();
      })
      if (value != this.initial) this.$emit('dirty');
      this.$emit('toggle', this.isShown);
    }
  }
}
</script>

<style>
.reviews {
  transition: height 0.15s ease-in-out;
}

.list-enter-active,
.list-leave-active {
  transition: all .15s ease-in-out;
}

.list-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}

.list-enter {
  opacity: 0;
  transform: translateY(-60px);
}

.reviews-section .hide-overlay {
  position: absolute;
  margin: -1em;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: .25em;
  background-color: transparent;
  transition: background-color .5s ease;
}

.reviews-section .btn-toggle {
  display: none;
}

.reviews-section:hover .hide-overlay {
  z-index: 0;
  /*border: 1px solid #777;*/
  outline: 2px solid rgba(40, 167, 69, .2);

}

.reviews-section.is-shown:hover .hide-overlay {
  outline: 2px solid rgba(220, 53, 69, .2);

}

.reviews-section:hover .btn-toggle {
  z-index: 1;
  text-align: center;
  position: absolute;
  right: 15px;
  bottom: .5em;
  display: inline-block;
}

.reviews-section:hover .hide-overlay .btn-toggle .material-icons {
  vertical-align: text-top;
  font-size: 1.1em;

}

.reviews-section .btn-outline-light:hover,
.reviews-section .btn-outline-light:active,
.reviews-section .btn-outline-light:focus {
  border-color: black;
  color: #000;
  ;
}

.heading-hidden {
  color: #aaa;
  text-decoration: line-through;
}

.reviews-section:hover .heading-hidden {
  color: #777;
  text-decoration: initial
}

.reviews-section.is-shown:hover h3 {
  color: #333;
}
</style>
